export default "__VITE_ASSET__b2b1f99d__"